import { QueryTuple, useLazyQuery } from '@apollo/client';
import { AppModule, Scalars } from '@bechtel/types';
import { GET_PROJECT_CONFIG_MODULES } from '@bechtel/client-gql';

export function useProjectModulesQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ modules: AppModule[] }, { id: Scalars['ID'] }> {
  const response = useLazyQuery<{ modules: AppModule[] }, { id: Scalars['ID'] }>(
    GET_PROJECT_CONFIG_MODULES,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
